import { jsx as _jsx } from "react/jsx-runtime";
var ChevronDown = function ChevronDown(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 15.4998C11.744 15.4998 11.488 15.4018 11.293 15.2068L7.29301 11.2068C6.90201 10.8158 6.90201 10.1838 7.29301 9.79276C7.68401 9.40176 8.31601 9.40176 8.70701 9.79276L12.012 13.0978L15.305 9.91776C15.704 9.53476 16.335 9.54576 16.719 9.94276C17.103 10.3398 17.092 10.9738 16.695 11.3568L12.695 15.2188C12.5 15.4068 12.25 15.4998 12 15.4998Z",
      fill: color
    })
  });
};
export default ChevronDown;